<template>
  <!-- <v-flex row class="container"> -->
    
      <!-- <v-flex xs4 sm4 md4 >
        
        <div class="text-uppercase" v-if="concepto.nombre">
          {{ concepto.nombre }}
        </div>
      </v-flex> -->
      <!-- <v-flex xs8 sm8 md8 > -->
        
    <div
      ref="chart"
      :style="'height:' + alto + 'px;'"
   
    />
    
    <!-- <span :class="'legend ' + cssClass" v-if="concepto.valor">
      {{ concepto.valor }}
    </span>     -->
    <!-- </v-flex> -->

    
  <!-- </v-flex> -->
</template>

<script>
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
let router;
let url = process.env.BASE_URL;
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
am4core.useTheme(am4themes_animated);

export default {
  name: "pnsPie",
  computed: {
    cssClass() {
      return this.link !== "" ? "link" : "";
    },
  },
  props: {
    concepto: {
      type: Array,
      required: false,
      default: null,
    },
    label: {
      type: Boolean,
      default: false,
    },
    trim: {
      type: String,
      required: false,
      default: "",
    },
    link: {
      type: String,
      required: false,
      default: "",
    },
    color: {
      type: String,
      required: false,
      default: "",
    },
  },
  data() {
    return {
      chart: "",
      pieColors: [],
      colores: ["#46c49e", "#99D558", "#0d93aa"],
      alto: 280
    };
  },
  methods: {
    renderChart() {
      if (this.concepto !== null) {

      let size = this.concepto.length
      this.alto = 280;
      if (size > 5)
        {
          this.alto = this.alto + ( size * 6)
        }

        let total = 0;
        let nameField = "nombre";
        let unidad = this.concepto[0].unidad;

        let chart = am4core.create(this.$refs.chart, am4charts.XYChart);
        chart.data = this.concepto;
        chart.padding(40, 40, 40, 40);
        
        chart.height = this.alto;
        
        chart.numberFormatter.numberFormat = ("es-CO", { maximumFractionDigits: 2 });

        let categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.dataFields.category = nameField;
        categoryAxis.renderer.minGridDistance = 10;
        categoryAxis.renderer.inversed = true;
        categoryAxis.renderer.grid.template.disabled = false;
        
        let label = categoryAxis.renderer.labels.template;
        label.truncate = true;
        label.wrap = false;
        label.maxWidth = 500;
        label.width = 500;

        let axisTooltip = categoryAxis.tooltip;
        axisTooltip.background.fill = am4core.color("#07BEB8");
        axisTooltip.background.strokeWidth = 0;
        axisTooltip.background.cornerRadius = 3;
        axisTooltip.background.pointerLength = 0;
        axisTooltip.dy = 5;

        let valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
        
        valueAxis.min = 0;

        let series = chart.series.push(new am4charts.ColumnSeries());
        series.dataFields.categoryY = nameField;
        series.dataFields.valueX = "valor";
        series.tooltipText = "{valueX.value}";
        series.columns.template.strokeOpacity = 0;
        series.columns.template.column.cornerRadiusBottomRight = 5;
        series.columns.template.column.cornerRadiusTopRight = 5;

        if (this.colores !== null && this.colores.length > 0) {
          let arr = [];
          this.colores.forEach((color) => {
            arr.push(am4core.color(color));
          });
          chart.colors.list = arr;
        }
        let labelBullet = series.bullets.push(new am4charts.LabelBullet());
        labelBullet.label.horizontalCenter = "left";
        labelBullet.label.dx = 10;
        labelBullet.label.truncate = false;
        labelBullet.label.text =
          "{values.valueX.workingValue} " + unidad;
        labelBullet.locationX = 1;

        // as by default columns of the same series are of the same color
        // we add adapter which takes colors from chart.colors color set
        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        categoryAxis.sortBySeries = series;

        chart.logo.height = -15000;
        this.chart = chart;
      }
    }
  },
  mounted() {
    router = this.$router;
    this.renderChart();
  },
  watch: {
    concepto: function (newVal, oldVal) {
      // console.log("Prop changed: ", newVal, " | was: ", oldVal);
      this.renderChart();
    },
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
    }
  },
};
</script>